import {Component, Injector, OnInit, ViewChild } from '@angular/core';
import {WhForwardingModel} from "../../../models/loads/wh-forwarding.model";
import {LoadsService} from "../../../services/loads/loads.service";
import {BaseFormComponentComponent} from "../../../shared/base-form-component/base-form-component.component";
import { ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import {WhStockModel} from "../../../models/loads/wh-stock.model";
import {WhForwardingPackEditModel} from "../../../models/loads/wh-forwarding-pack-edit.model";
import EntityUtil from 'src/app/shared/entity.util'
import { DocumentBtnComponent } from 'src/app/shared/document-btn/document-btn.component';
import {SimpleEntity} from "../../../models/simple-entity.model";
import {UserService} from "../../../services/user/user.service";
import { ActivatedRoute } from '@angular/router';
import { AutocompleteComponent } from 'src/app/shared/autocomplete/autocomplete.component';
import { SelectBoxComponent } from 'src/app/shared/select-box/select-box.component';

@Component({
  selector: 'app-create-request',
  templateUrl: './create-request.component.html',
  styleUrls: ['./create-request.component.scss']
})

export class CreateRequestComponent extends BaseFormComponentComponent implements OnInit {

    whForwardingModel: WhForwardingModel = new WhForwardingModel();
    products: WhStockModel[] = [];
    selectedProduct: any = null;
    productCode:  SimpleEntity = null;
    filteredProducts: WhStockModel[] = [];
    filtered: any = false;
    filterProductName: string = null;
    whForwardingModels: WhForwardingModel[] = [];
    imageDisplay: boolean = false;
    photoData: string = null;
    userCompany: SimpleEntity = null;
    totalCount: any = 0;
    disabledOwnerTypes: any[] = [];
    requestedProducts: WhStockModel[] = [];
    isWarehouseDisabled: boolean = false;

    @ViewChild('consigneeRef') consigneeAutocomplete : AutocompleteComponent;
    @ViewChild('ownerTypeRef') ownerTypeRef : SelectBoxComponent;
    first = 0;

    constructor(protected injector: Injector, private route: ActivatedRoute, private loadService: LoadsService, public viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver, private userService: UserService) {
      super(injector);
    }

    ngOnInit(): void {
        this.whForwardingModel.orderDate = new Date();
        this.userCompany = this.userService.getCompany();
        this.whForwardingModel.forwardingType = this.route.snapshot.queryParamMap.get('type');
    }


    ngAfterViewInit(): void {
      if(this.whForwardingModel.forwardingType && this.whForwardingModel.forwardingType == 'fromWarehouse') {
        this.consigneeAutocomplete.defaultValue = this.userCompany;
        this.ownerTypeRef.disabledOptions =  [{"name":"Sözleşmeli","code":"SK"} , {"name":"Kargo","code":"CARGO"}];
      }
      if(this.whForwardingModel.forwardingType && this.whForwardingModel.forwardingType == 'toSalePoint') {
        this.ownerTypeRef.disabledOptions =  [{name: 'Tek Seferlik Kiralık', code: 'TSK'}, {name: 'Özmal', code: 'OZ'}];
      }
    }

    getLoadStocks(page : number) {
        this.filtered = false;
      if(!this.whForwardingModel.warehouse || !this.whForwardingModel.warehouse?.id) {
        this.products = [];
        return;
      }

        const productsId = [];

        this.isLoading = true;
        this.loadService.searchwhProductWithResponse(this.whForwardingModel.warehouse?.id, null, null, this.selectedProduct?.name ? this.filterProductName : this.selectedProduct, this.productCode?.name, null, null,true,page).subscribe(res => {
            this.totalCount = res.headers.get('Total-Elements');
            this.requestedProducts = this.requestedProducts.filter(product => product.quantity > 0);
            this.requestedProducts.forEach(value => productsId.push(value.id));
            this.products = [];
            res.body.forEach(value => {
                if (!productsId.includes(value.id)) {
                    this.products.push(value);
                }
            });
            this.isLoading = false;
        });
    }

    async save(form) {
      if(!this.isValid()) return;

      const products = this.getWhStock();
      if(products.length == 0) {
        this.showMessage('warn', 'Uyarı', 'Lütfen ürün stok miktarı belirtiniz.')
        return;
      }

      this.whForwardingModel.products = []
      products.forEach(p => { this.whForwardingModel.products.push(this.whStockToWhProductPack(p))});


      try {
        this.isLoading = true;
        this.whForwardingModel.orderDate = new Date(this.whForwardingModel.orderDate.getTime() + Math.abs(this.whForwardingModel.orderDate.getTimezoneOffset() * 60000));
        this.whForwardingModels = await  this.loadService.createOrUpdateWhForwarding(this.whForwardingModel).toPromise();
        this.requestedProducts = [];
        if(this.whForwardingModels.length == 1) {
          this.confirm("Dijital arşive dosya eklemek istiyor musunuz ?").then(() => {
            this.showDigitalArchive()
          })
        } else {
          this.showMessage('warn', 'Bilgi', `${this.whForwardingModels.length} adet depo sevkiyat kaydı oluşturuldu. Referans No: ${this.whForwardingModels.map(s => s.referenceNo).join()}`)
        }

        this.whForwardingModel = new WhForwardingModel()
        this.whForwardingModel.products = [];
        this.whForwardingModel.warehouse = null;
        this.whForwardingModel.forwardingType = this.route.snapshot.queryParamMap.get('type');
        this.products = [];
        this.isLoading = false;
        this.isWarehouseDisabled = false;
        this.showMessage('success', '', 'Kayıt başarılı.')
      } catch  {
        this.isLoading = false;
      }

    }

    getWhStock() {
        return this.requestedProducts.filter(f => f.quantity > 0);
    }

    insertToRequestedList(product: WhStockModel) {
        this.isWarehouseDisabled = true;
        this.requestedProducts.push(product);
        this.products.splice(this.products.indexOf(product), 1);
    }


    whStockToWhProductPack(whStock: WhStockModel): WhForwardingPackEditModel {
      const whForwardingPackEditModel =  new WhForwardingPackEditModel();
      whForwardingPackEditModel.whProduct =  EntityUtil.toSimple(whStock.whProduct);
      whForwardingPackEditModel.quantity = whStock.quantity;
      whForwardingPackEditModel.whStock = whStock;
      return  whForwardingPackEditModel;
    }

    onInputQuantity(product: WhStockModel) {
      setTimeout(() => {
        if(product.quantity > this.getTotalStockByStocks(product)) {
          product.quantity = null;
          this.showMessage('warn', 'Uyarı', `En fazla ${this.getTotalStockByStocks(product)} adet talep edebilirsiniz.`);
        }
      }, 500)
    }

    onChangeOwnerType(event: any) {
      this.whForwardingModel.branch = null;
      this.whForwardingModel.consigneeAddress = null;
      this.whForwardingModel.consignee = null;
      this.consigneeAutocomplete.value = null;

      if(this.whForwardingModel.forwardingType && this.whForwardingModel.forwardingType == 'fromWarehouse' || event == 'OZ') {
        this.whForwardingModel.consignee = this.consigneeAutocomplete.defaultValue || this.userCompany;
        this.consigneeAutocomplete.value  = this.consigneeAutocomplete.defaultValue || this.userCompany
      }

    }

    showDigitalArchive() {
      let factory = this.componentFactoryResolver.resolveComponentFactory(DocumentBtnComponent);
      let componentRef = this.viewContainerRef.createComponent(factory);
      componentRef.instance.entityId = this.whForwardingModels[0].id;
      componentRef.instance.showModal = true;
    }

    getProductNameAndLoadStocks(){
     this.filterProductName = this.selectedProduct.name;
     this.getLoadStocks(0);
    }

    showDialog(photoData) {
        if (photoData) {
            this.photoData = photoData;
            this.imageDisplay = true;
        }
    }
    refresh() {

    }

    getTotalStockByStocks(mainStock: WhStockModel) {
        if (mainStock.stocks) {
            let totalStock = 0;
            mainStock.stocks.forEach(stock => {
                totalStock += stock.stock;
            });
            return totalStock;
        }
        return mainStock.stock;
    }

    onPage(event: any) {
        this.getLoadStocks(event.first /10);
    }
}
